import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { PageOne, PageTwo, PageThree } from './components';
;
export const DocumentTwentyOne = memo((props) => (_jsxs(_Fragment, { children: [_jsx(PageOne, {}), _jsx(PageTwo, {}), _jsx(PageThree, { ...props })] })));
